package one.healthium.tutorial.screens

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import loco.GENERAL_CONTINUE
import one.healthium.onboarding.ui.user_binding.UserProvider
import one.healthium.tutorial.domain.TutorialScreenConfig
import one.healthium.ui.common.utils.toColor
import one.healthium.ui.common.utils.toTextStyle
import one.healthium.ui.compose.components.AppButton
import one.healthium.ui.compose.components.AppText
import one.healthium.ui.compose.theme.AppTheme
import org.jetbrains.compose.resources.stringResource

interface TutorialInfoEventDelegate {
    fun onNextClicked()
}

@Composable
fun TutorialInfoScreen(
    screenConfig: TutorialScreenConfig.TutorialInfoScreenConfig,
    eventDelegate: TutorialInfoEventDelegate,
) {
    TutorialInfoScreenContent(
        screenConfig = screenConfig,
        onNextClicked = eventDelegate::onNextClicked,
    )
}

@Composable
private fun TutorialInfoScreenContent(
    screenConfig: TutorialScreenConfig.TutorialInfoScreenConfig,
    onNextClicked: () -> Unit,
) {
    UserProvider {
        Column(
            modifier = Modifier
                .navigationBarsPadding()
                .padding(horizontal = 32.dp)
                .fillMaxHeight()
                .verticalScroll(rememberScrollState()),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            Spacer(Modifier.height(36.dp))
            AppText(
                text = screenConfig.title?.bindUserPlaceholders(),
                style = screenConfig.titleStyle.toTextStyle(AppTheme.tutorialStyle?.titleStyle ?: AppTheme.textStyles.secondary_30_500),
                color = screenConfig.titleStyle?.color?.toColor() ?: AppTheme.colors.text100,
                textAlign = TextAlign.Center,
            )
            Spacer(Modifier.height(16.dp))
            AppText(
                text = screenConfig.message?.bindUserPlaceholders(),
                style = AppTheme.tutorialStyle?.messageStyle ?: AppTheme.textStyles.secondary_18_400,
                color = AppTheme.colors.text500,
                textAlign = TextAlign.Center,
            )
            Spacer(Modifier.height(24.dp))
            Spacer(Modifier.weight(1f))
            AppButton(
                modifier = Modifier.defaultMinSize(minWidth = 176.dp),
                onClick = onNextClicked,
            ) {
                Text(text = screenConfig.ctaTitle ?: stringResource(loco.Res.string.GENERAL_CONTINUE))
            }
            Spacer(Modifier.height(50.dp))
        }
    }
}